import request from '@/api/request'

const aftersaleList = (params) => {
  // 申请售后列表
  return request({
    url: '/api/v1/app/trade/order/pagingOrderInfo',
    method: 'GET',
    params
  })
}

const afterthedetails = (params) => {
  // 售后详情
  return request({
    url: '/api/v1/app/trade/order/getOrderAftermarketDetail',
    method: 'GET',
    params
  })
}

const afterrecord = (params) => {
  // 售后申请记录
  return request({
    url: '/api/v1/app/trade/order/pagingOrderAftermarket',
    method: 'GET',
    params
  })
}

const refundOrder = (data) => {
  // 售后申请
  return request({
    url: '/api/v1/app/trade/order/refundOrderItem',
    method: 'POST',
    data
  })
}

export default {
  aftersaleList,
  afterthedetails,
  afterrecord,
  refundOrder
}
